import { render } from "./PersonListByQualExpiration.vue?vue&type=template&id=2ef7edf4&scoped=true"
import script from "./PersonListByQualExpiration.vue?vue&type=script&lang=js"
export * from "./PersonListByQualExpiration.vue?vue&type=script&lang=js"

import "./PersonListByQualExpiration.vue?vue&type=style&index=0&id=2ef7edf4&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef7edf4"]])

export default __exports__